module.exports = __webpack_public_path__ + "static/media/Those Were the Days.68f0acb5.jpg";